import React from 'react'
import { observer } from 'mobx-react'
import scrollToTop from 'decorators/scrollToTop'
import ShadowBox from 'components/ShadowBox'
import { FlexItem } from 'components/Flex'
import TermsDialog from 'components/TermsDialog'
// import Modal from 'components/Modal'
// import { Dialog, DialogTitle, DialogContent, DialogFooter, DialogButton } from 'components/Dialog'
import { match } from 'utils/patternMatchUtil'
import { PaymentMethodPicker, FeeBreakdown } from './Boxes'
import './styles.sass'

@scrollToTop
@observer
export default class FeeBreakdownStep extends React.Component {
  componentWillUnmount () {
    this.props.step.closeCheckout()
  }

  render () {
    const { step } = this.props
    return (
      <div className="fee-breakdown-step">
        <div className="container">
          <div className="columns">
            <div className="column">
              <FlexItem className="description-row">
                <div className="content header-content">
                  <h4 className="main-title">
                    Why Taxfyle?
                  </h4>
                  <p className="subtitle">
                    Get your taxes done by a CPA or IRS Enrolled Agent for
                    <strong> 40% cheaper</strong> than H&R Block
                  </p>
                </div>
              </FlexItem>
              <FlexItem className="description-row">
                <QuoteBox {...step.currentTestimonial} />
              </FlexItem>
              <FlexItem className="description-row">
                <Timeline />
              </FlexItem>
            </div>
            <div className="column">
              <FlexItem className="breakdown-column">
                {match(step.view, {
                  breakdown: () => <FeeBreakdown step={step} />,
                  payment: () => <PaymentMethodPicker step={step} />
                })}
              </FlexItem>
              <FlexItem>
                <div className="footnotes has-text-centered content has-spacing-top">
                  <p>
                    Please note that we will charge the fees up front to verify your payment method.
                    Once your taxes have been filed, the remaining amount is charged.
                  </p>
                </div>
              </FlexItem>
            </div>
          </div>
        </div>
        <TermsDialog
          state={step.termsDialog}
        />
        {/*
        <Modal isOpened={step.showingFreeExtensionsInfo} onRequestClose={(() => step.closeFreeExtensionsInfo())}>
          <Dialog>
            <DialogTitle>Did you know...</DialogTitle>
            <DialogContent>
              <div className="content is-medium">
                <p>
                  Taxfyle will file an extension automatically <strong>free of charge</strong> if
                  your return is not completed before the deadline.
                </p>
              </div>
            </DialogContent>
            <DialogFooter>
              <DialogButton onClick={() => step.closeFreeExtensionsInfo()}>Good to know!</DialogButton>
            </DialogFooter>
          </Dialog>
        </Modal>
        */}
      </div>
    )
  }
}

let Timeline = () => (
  <div className="timeline">
    <h4 className="next-steps">
      Next Steps
    </h4>
    <ul>
      <li>
        <div className="bullet-img review">
          <img src={require('./img/review.png')}/>
        </div>
        <div className="desc">
          <p>Review your order</p>
        </div>
      </li>
      <li>
        <div className="bullet blue"></div>
        <div className="desc">
          <p>We'll pair you with a Tax Pro</p>
        </div>
      </li>
      <li>
        <div className="bullet blue"></div>
        <div className="desc">
          <p>Chat and upload your tax docs</p>
        </div>
      </li>
      <li>
        <div className="bullet-img money">
          <img src={require('./img/get-money.png')}/>
        </div>
        <div className="desc">
          <p>Sit back, relax and let your Pro do the work</p>
        </div>
      </li>
    </ul>
  </div>
)

let QuoteBox = ({ quote, username }) => (
  <ShadowBox className="quote-box" level={1}>
    <blockquote>
      <span>What our customers say</span>
      {quote} - {username}
    </blockquote>
  </ShadowBox>
)



// WEBPACK FOOTER //
// ./src/client/screens/ProjectWizard/Steps/FeeBreakdown/index.jsx